"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Fire = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Fire = function Fire(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.613 8.47C12.435 5.285 8.24 5.113 9.254.486c.075-.343-.277-.609-.562-.43C5.968 1.728 4.01 5.076 5.653 9.46c.135.36-.27.695-.562.46-1.358-1.068-1.5-2.605-1.38-3.706.044-.405-.466-.6-.683-.265C2.518 6.761 2 8.071 2 10.046a6.17 6.17 0 005.109 5.883c1.823.242 3.796-.11 5.213-1.459 1.56-1.506 2.13-3.91 1.29-6zM6.65 12.393c1.08-.273 1.635-1.084 1.785-1.802.248-1.116-.72-2.208-.067-3.972.248 1.46 2.453 2.372 2.453 3.964.06 1.974-1.995 3.668-4.17 1.81z",
    fill: "currentColor"
  }));
};

exports.Fire = Fire;
var _default = Fire;
exports.default = _default;